import '../../../css/widgetssettings.css';
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import MonitorService from '../../../controllers/MonitorService';
import { selectionTypes, channels } from '../../utils/consts';
import { SelectBox } from 'devextreme-react/select-box';
import DualListBox from 'react-dual-listbox';

class WidgetSettings extends Component {

    constructor(props) {

        super(props);

        this.state = {
            groups: [],
            dualGroups: [],
            selectedGroups: [],
            groupId: -1,
            groupName: "",
            campaign: "",
            channel: "",
            channelName: ""
        };

        this.setGroups = this.setGroups.bind(this);
        this.wrapperRef = React.createRef();
        this.handleChange = this.handleChange.bind(this);
        this.handleSend = this.handleSend.bind(this);
        this.handleChannelChange = this.handleChannelChange.bind(this);
        this.setSelectedGroups = this.setSelectedGroups.bind(this);
    }

    setGroups(res) {
        if (res.data != null && res.data.length > 0) {
            let groups = [];

            if (this.props.selectionType === selectionTypes.GROUP || this.props.selectionType === selectionTypes.CHANNEL) {
                groups = [{ groupId: -1, groupName: this.props.t("all2") }].concat(res.data);
            } else if (this.props.selectionType === selectionTypes.CAMPAIGN) {
                groups = [{ groupId: -1, campaign: this.props.t("all") }].concat(res.data);
            }
            else {
                groups = res.data;
            }
            this.setState({
                groups: groups,
                groupId: this.props.groupId,
                dualGroups: groups.map(x => { return { value: x.groupId, label: x.groupName } })
            });
        }
    }
    handleChannelChange(value) {
        let channel = channels.find(x => x.id === value);
        if (channel) {
            this.setState({
                channel: value,
                channelName: value ? channel.name : ""
            });
        }
    };
    setSelectedGroups(value) {
        this.setState({ selectedGroups: value });
    }
    componentDidMount() {
        MonitorService.getSupervisedGroups(this.props.token, this.setGroups);
    }

    componentWillUnmount() {

    }

    handleChange(value) {

        let group = this.state.groups.find(x => x.groupId === value);
        if (group) {
            this.setState({
                groupId: group.groupId,
                groupName: group.groupName,
                campaign: group.campaign,
            })
        }
    }


    handleSend(e) {
        e.preventDefault();

        if (this.props.selectionType === selectionTypes.GROUP)
            this.props.setGroup(this.state.groupId, this.state.groupName);

        if (this.props.selectionType === selectionTypes.GROUPMULTIPLE)
            this.props.setGroups(this.state.selectedGroups);

        if (this.props.selectionType === selectionTypes.CAMPAIGN)
            this.props.setCampaign(this.state.groupId, this.state.campaign);

        if (this.props.selectionType === selectionTypes.CHANNEL)
            this.props.setGroupAndChannel(this.state.groupId, this.state.groupName, this.state.channel, this.state.channelName);

        if (this.props.selectionType === selectionTypes.MESSAGESQUEUE)
            this.props.setGroupsAndChannel((this.state.selectedGroups || []), this.state.channel, this.state.channelName);

    }
    render() {
        return (
            <div ref={this.wrapperRef} className={"position-absolute menu-user menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color py-4 fs-6 w-400px " + (this.props.showSettings ? "show" : "")}>

                {
                    (this.props.selectionType === selectionTypes.CHANNEL || this.props.selectionType === selectionTypes.MESSAGESQUEUE) &&
                    <div className="menu-item px-5">
                        <div className="mb-10">
                            <label className="form-label fw-semibold">{this.props.t("channel")}</label>
                            <div>
                                <SelectBox
                                    dataSource={channels.map(x => { return { id: x.id, name: this.props.t(x.name) } })}
                                    value={this.state.channel}
                                    onValueChange={this.handleChannelChange}
                                    valueExpr="id"
                                    displayExpr="name"
                                    searchEnabled={true}
                                    dropDownButtonRender={() => { return (<FontAwesomeIcon icon={duotone("down")} />) }}
                                />
                            </div>
                        </div>
                    </div>
                }
                {
                    (this.props.selectionType === selectionTypes.GROUP || this.props.selectionType === selectionTypes.CHANNEL) &&
                    <div className="menu-item px-5">
                        <div className="mb-10">
                            <label className="form-label fw-semibold">{this.props.t("group")}</label>
                            <div>
                                <SelectBox
                                    dataSource={this.state.groups}
                                    value={this.state.groupId}
                                    onValueChange={this.handleChange}
                                    valueExpr="groupId"
                                    displayExpr="groupName"
                                    searchEnabled={true}
                                    dropDownButtonRender={() => { return (<FontAwesomeIcon icon={duotone("down")} />) }}
                                />
                            </div>
                        </div>
                    </div>
                }
                {
                    (this.props.selectionType === selectionTypes.GROUPMULTIPLE || this.props.selectionType === selectionTypes.MESSAGESQUEUE) &&
                    <div className="menu-item px-5">
                        <div className="mb-10">
                            <label className="form-label fw-semibold">{this.props.t("groups")}</label>
                            <div>
                                <DualListBox
                                    canFilter
                                    options={this.state.dualGroups}
                                    selected={this.state.selectedGroups}
                                    onChange={this.setSelectedGroups}
                                    showHeaderLabels={true}
                                    icons={{
                                        moveLeft: <FontAwesomeIcon icon={duotone("left")} />,
                                        moveAllLeft: [
                                            <FontAwesomeIcon key={0} icon={duotone("left")} />,
                                            <FontAwesomeIcon key={1} icon={duotone("left")} />,
                                        ],
                                        moveRight: <FontAwesomeIcon icon={duotone("right")} />,
                                        moveAllRight: [
                                            <FontAwesomeIcon key={0} icon={duotone("right")} />,
                                            <FontAwesomeIcon key={1} icon={duotone("right")} />,
                                        ]
                                    }}

                                />
                            </div>
                        </div>
                    </div>
                }
                {
                    this.props.selectionType === selectionTypes.CAMPAIGN &&
                    <div className="menu-item px-5">
                        <div className="mb-10">
                            <label className="form-label fw-semibold">{this.props.t("campaign")}</label>
                            <div>
                                <SelectBox
                                    dataSource={this.state.groups.filter(x => x.campaign)}
                                    value={this.state.groupId}
                                    onValueChange={this.handleChange}
                                    valueExpr="groupId"
                                    displayExpr="campaign"
                                    searchEnabled={true}
                                    dropDownButtonRender={() => { return (<FontAwesomeIcon icon={duotone("down")} />) }}
                                />
                            </div>
                        </div>
                    </div>
                }
                <div className="d-flex justify-content-end">
                    <button type="reset" className="btn btn-sm btn-light btn-active-light-primary me-2" onClick={e => { e.preventDefault(); this.props.toggleSettings(); }}>{this.props.t("close")}</button>
                    <button type="submit" className="btn btn-sm btn-primary" onClick={this.handleSend}>{this.props.t("send")}</button>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
    };
};

export default compose(connect(mapStateToProps, null), withTranslation())(WidgetSettings);